var pickCards = $(".covers-CoversPicks-Card");
$.each(pickCards, function (index, el) {
    var body = $(el).find('div.pick-card-body');
    var analysis = $(el).find('.pick-analysis');
    var cta = $(body).find('a.ShowMore-CTA');
    var analysisLength = parseInt($.trim($(analysis)[0].innerText.length));
    if (analysisLength <= 175) {
        $(cta).hide();
        $(analysis).css('-webkit-line-clamp', 'inherit');
    }
    $(cta).on('click', function (event) {
        event.preventDefault();
        if ($(cta).attr('data-click-state') == 1) {
            $(cta).attr('data-click-state', 0);
            $(cta).text('Show more');
            $(analysis).css('-webkit-line-clamp', '4');
            $(analysis).css('max-height', '400px');
        } else {
            $(cta).attr('data-click-state', 1);
            $(cta).text('Show less');
            $(analysis).css('-webkit-line-clamp', 'inherit');
        }
    });
});

function toggleFaqArrow(e) {
    if (!$(e).hasClass("faq-open")) {
        $(e).find(".faq-caret").toggleClass("faq-open");
        $(e).find(".hiddenSpan").toggleClass("hideFAQtoggle");
    }
}
// Created this function to check whether odds are negative or positive
function isNegative(num) {
    if (Math.sign(num) === -1) {
        return true;
    }
    return false;
}
// Returning to win amount based on negative or positive odds 
function returnToWin(wager, odds, isNegative) {
    if (isNegative) {
        return (wager / (-1 * (odds / 100))).toFixed(2);
    } else {
        return (wager * (odds / 100)).toFixed(2);
    }
}
// Setting payout to frontend element with total payout amount
function setPayout(element, payout) {
    if (!isNaN(payout))
        return $(element).text("$" + payout.toFixed(2))
}
// Payout calculation
var card = $(".covers-CoversPicks-Card");
$(card).each((index, el) => {
    var toWin = "";
    var payout = "";
    var best_odds_block = $(el).find("div.pick-best-n-compare-odds-block");
    var compare_odds_block = $(el).find("div.pick-compare-odds-block");
    var bestOdds = $(best_odds_block).data("odds");
    var bestOddsPayout = $(el).find("span#calculated-payout");
    var select = $(el).find("select");
    var wager = $(select).val();
    var isNegativeOdds = isNegative(Number(bestOdds)); // deciding positive or negative odds, return true for negative
    toWin = returnToWin(wager, bestOdds, isNegativeOdds); // return to win amount
    payout = Number(toWin) + Number(wager); // payout => adding toWin + wager amount
    setPayout(bestOddsPayout, payout); // setting payout for best odds
    // Compared odds
    var compare_odds_rows = $(compare_odds_block).find("div.other-odds-row");
    $(compare_odds_rows).each((index, el) => {
        var compareToWin = "";
        var comparePayout = "";
        var odds = $(el).data("odds");
        var payout_amount_span = $(el).find("span#payout-amount");
        var isNegativeOdds = isNegative(Number(odds)); // deciding positive or negative odds, return true for negative
        compareToWin = returnToWin(wager, odds, isNegativeOdds); // return to win amount
        comparePayout = Number(compareToWin) + Number(wager); // payout => adding toWin + wager amount
        setPayout(payout_amount_span, comparePayout); // setting payout for compare odds
    });
    // Select change event
    $(select).change((event) => {
        wager = event.target.value;
        toWin = returnToWin(wager, bestOdds, isNegativeOdds); // return to win amount
        payout = Number(toWin) + Number(wager);
        setPayout(bestOddsPayout, payout); // setting payout for best odds on event change
        $(compare_odds_rows).each((index, el) => {
            var odds = $(el).data("odds");
            var payout_amount_span = $(el).find("span#payout-amount");
            var isNegativeOdds = isNegative(Number(odds)); // deciding positive or negative odds, return true for negative
            var compareToWin = "";
            var comparePayout = "";
            compareToWin = returnToWin(wager, odds, isNegativeOdds); // return to win amount
            comparePayout = Number(compareToWin) + Number(wager); // payout => adding toWin + wager amount
            setPayout(payout_amount_span, comparePayout); // setting payout for compare odds on event change
        });
    });
});